/**
 * @deprecated Use @ordermentum/ui-shared/foundations/font
 */
export const FONT_SIZE = {
  XXS: '0.675rem',
  XS: '0.75rem',
  SM: '0.875rem',
  BASE: '1rem',
  LG: '1.125rem',
  XL: '1.5rem',
  '2XL': '1.875rem',
  '3XL': '2.25rem',
  '4XL': '3rem',
};

/**
 * @deprecated Use @ordermentum/ui-shared/foundations/font
 */
export const FONT_WEIGHT = {
  LIGHT: 300,
  NORMAL: 400,
  MEDIUM: 500,
  BOLD: 600,
  XBOLD: 700,
};
